// import { useSelector } from "react-redux";


const AkshayaPatraStoreManager = () => {
    //   const OrgId = useSelector((state) => state.auth.org_id)
      // console.log(OrgId, 'org_id__________')
      
      return (
        <div className="iframe-div">
            <iframe src= {`https://iiplwork.retool.com/embedded/public/3fcde6ca-1a47-4e08-b4cd-c4b06aa0233e`}
            className="iframe-style"></iframe>
        </div>
      )
    };
    
    export default AkshayaPatraStoreManager;
    